const identifyUser = (user) => {
	try {
		if (window.smartlook) {
			window.smartlook('identify', user.id, {
				name: `${user.first_name} ${user.last_name}`,
				email: user.email,
			});
		}
	} catch (err) {
		console.log(err);
	}
};
export default { identifyUser };
